"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _update = _interopRequireDefault(require("./update"));

var _keyArray = _interopRequireDefault(require("unmutable/keyArray"));

var _pipeWith = _interopRequireDefault(require("unmutable/pipeWith"));

var _default = function _default(mapper) {
  return function (parcelData) {
    var keys = (0, _keyArray["default"])()(parcelData.value);
    return _pipeWith["default"].apply(void 0, [parcelData].concat((0, _toConsumableArray2["default"])(keys.map(function (key) {
      return (0, _update["default"])(key, function (childParcelData) {
        return mapper(childParcelData, key, parcelData);
      });
    }))));
  };
};

exports["default"] = _default;